import * as yup from 'yup'

const schema = yup.object().shape({
  domain: yup.string().required(),
  confirmed: yup.string().required(),
})

export default schema
